
function UrlHelper(){
	this.add = function(url, title, data){
		//console.log('set url = ' + url);
		history.pushState(data, title, url);
	};
	this.replace = function(url, title, data){
		history.replaceState(data, title, url);
	};
	this.getCurrentRequestUri = function(){
		var path = location.pathname;
		var params = window.location.search;
		return path + params;
	};
	this.getCurrentUrl = function(){
		return window.location.href;
	};
	this.scrollTo = function(el){
		$('html, body').scrollTop($(el).offset().top);
	};
	this.getParamValueFromQueryString = function(paramName, defaultValue){
		var defVal = defaultValue || false;
		var params = window.location.search;

		if(!params){
			return defVal;
		}

		if(params.indexOf(paramName + '=')!== -1){
			var bregExp = new RegExp(paramName + "=([^&]+)");
			var match = bregExp.exec(params);
			return match[1];
		} else {
			return defVal;
		}
	};
	this.setQueryStringParam = function(paramName, paramValue, defaultValue){
		var params = window.location.search;
		var regExp = new RegExp(paramName + "=([^&]+)");

		if(paramValue === defaultValue){
			params = params.replace(regExp, '');
			if(params === '?'){
				params = '';
			}
			if(params.substr(params.length - 1) === '&'){
				params = params.substr(0, params.length - 1);
			}
		} else {
			if(!params){
				params = '?' + paramName + '=' + paramValue;
			} else {
				if(params.indexOf(paramName + '=') === -1){
					params = params + '&'  + paramName + '=' + paramValue;
				} else {
					params = params.replace(regExp, paramName + '=' + paramValue);
				}
			}
		}
		return params;
	};
}

urlhelper = new UrlHelper();